<template>
  <div>
    <table class="w-full border">
      <thead>
        <tr class="text-left text-[#09518C]">
          <th
            v-for="column in columns"
            :key="column.key"
            :class="column.className"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr v-for="item in paginatedData" :key="item.id" class="border-b-2">
          <td
            v-for="column in columns"
            :key="column.key"
            :class="column.className"
          >
            <template v-if="column.key === 'actions'">
              <slot name="actions" :item="item" />
            </template>
            <template v-else-if="column.classCondition">
              <span :class="column.classCondition(item)">
                {{ item[column.key] }}
              </span>
            </template>
            <template v-else>
              {{ renderCell(item, column) }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="pagination-controls flex justify-center mt-4 pb-3"
      v-if="data.length > pageSize"
    >
      <button
        class="bg-[#8DC63F] hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] text-white text-xs p-2 rounded-md"
        @click="previousPage"
        :disabled="currentPage === 1"
      >
        Previous
      </button>
      <span class="mx-4 mt-2 text-xs"
        >Page {{ currentPage }} of {{ totalPages }}</span
      >
      <button
        class="bg-[#8DC63F] hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] text-white text-xs p-2 rounded-md"
        @click="nextPage"
        :disabled="currentPage === totalPages"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    renderCell: {
      type: Function,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10, // Default page size
    },
  },
  setup(props) {
    const currentPage = ref(1);
    // const data = ref(props.data);

    const totalPages = computed(() => {
      return Math.ceil(props.data.length / props.pageSize);
    });

    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * props.pageSize;
      const end = start + props.pageSize;
      return props.data.slice(start, end);
    });

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value += 1;
      }
    };

    const previousPage = () => {
      if (currentPage.value > 1) {
        currentPage.value -= 1;
      }
    };

    // watch(data, (newValue, oldValue) => {
    //   console.log(newValue, "newval");
    //   console.log(oldValue, "oldval");
    // });

    return {
      currentPage,
      totalPages,
      paginatedData,
      nextPage,
      previousPage,
    };
  },
};
</script>
